import { render, staticRenderFns } from "./TestimonialsAdd.vue?vue&type=template&id=b562692a&scoped=true"
import script from "./TestimonialsAdd.vue?vue&type=script&lang=js"
export * from "./TestimonialsAdd.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsAdd.vue?vue&type=style&index=0&id=b562692a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b562692a",
  null
  
)

export default component.exports